import React from 'react';

const Clients = () => {
    return (
        <div className="clients">
            <div className="client_item">
                <div className="client_imgbox">
                    <img
                        className="primary"
                        src="images/clients/client_1_1.png"
                        alt=""
                    />
                    <img
                        className="secondary"
                        src="images/clients/client_1_2.png"
                        alt=""
                    />
                </div>
            </div>
            <div className="client_item">
                <div className="client_imgbox">
                    <img
                        className="primary"
                        src="images/clients/client_2_1.png"
                        alt=""
                    />
                    <img
                        className="secondary"
                        src="images/clients/client_2_2.png"
                        alt=""
                    />
                </div>
            </div>
            <div className="client_item">
                <div className="client_imgbox">
                    <img
                        className="primary"
                        src="images/clients/client_3_1.png"
                        alt=""
                    />
                    <img
                        className="secondary"
                        src="images/clients/client_3_2.png"
                        alt=""
                    />
                </div>
            </div>
            <div className="client_item">
                <div className="client_imgbox">
                    <img
                        className="primary"
                        src="images/clients/client_4_1.png"
                        alt=""
                    />
                    <img
                        className="secondary"
                        src="images/clients/client_4_2.png"
                        alt=""
                    />
                </div>
            </div>
            <div className="client_item">
                <div className="client_imgbox">
                    <img
                        className="primary"
                        src="images/clients/client_5_1.png"
                        alt=""
                    />
                    <img
                        className="secondary"
                        src="images/clients/client_5_2.png"
                        alt=""
                    />
                </div>
            </div>
        </div>
    );
};

export default Clients;